export default "__VITE_ASSET__CBjrLLi5__"